import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { Stack, Typography, Grid, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { getDatabase, ref as dbref, runTransaction, set, child, get, update, remove } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const firebaseConfig = {
  apiKey: 'AIzaSyDLVrlBPuai36n-i4F5HQVTjSMkVeGVBak',
  authDomain: 'onetweb-e3d8e.firebaseapp.com',
  databaseURL: 'https://onetweb-e3d8e-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'onetweb-e3d8e',
  storageBucket: 'onetweb-e3d8e.firebasestorage.app',
  messagingSenderId: '60910494595',
  appId: '1:60910494595:web:2dc6bf320d67371af04cb6',
  measurementId: 'G-0ZTHXZBNP9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const rtdb = getDatabase(app);

// ----------------------------------------------------------------------

export default function Page() {
  const [row, setRow] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    const arr = [];
    get(child(dbref(rtdb), `partnerlogo`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((doc) => {
            arr.push({
              ...doc.val(),
            });
          });

          setRow(arr);
          setLoading(false);
        } else {
          setRow([]);
          setLoading(false);
          console.log('No data available');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  if (loading) {
    return (
      <Grid style={{ width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        <Grid
          style={{
            width: '100%',
            marginTop: 60,
            maxWidth: 1200,
            display: 'flex',
            padding: 25,
            height: '80vh',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            <CircularProgress color="inherit" />
          </Box>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Helmet>
        <title> Partners | OneT | Leading DevSecOps Service Provider</title>
      </Helmet>

      <Grid
        style={{
          top: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        {matches ? (
          <Grid
            style={{
              zIndex: -1,
              position: 'fixed',
              top: 0,
              backgroundColor: '#1b0049',
              width: '100%',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <video height="100%" className="videoTag" playsInline autoPlay loop muted>
              <source src="/assets/videobg.mp4" type="video/mp4" />
            </video>
          </Grid>
        ) : (
          <Grid
            style={{
              zIndex: -1,
              position: 'fixed',
              top: 0,
              backgroundColor: '#1b0049',

              height: '110vh',
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'column',
            }}
          >
            <video height="100%" className="videoTag" playsInline autoPlay loop muted>
              <source src="/assets/videobg.mp4" type="video/mp4" />
            </video>
          </Grid>
        )}

        <Grid
          style={{
            maxWidth: 1200,
            zIndex: 1,
            marginTop: 120,
            width: '100%',
            display: 'flex',
            padding: 25,
            paddingTop: 60,
            paddingBottom: 80,
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: 'Transparent',
          }}
        >
          <Typography style={{ fontWeight: 'bold', fontSize: 40, color: 'white', textTransform: 'uppercase' }}>
            Key Technology Partners
          </Typography>
          <Typography
            style={{ marginTop: -10, fontWeight: 'lighter', fontSize: 40, color: 'white', textTransform: 'uppercase' }}
          >
            Building Futures with Expertise
          </Typography>
          <Typography style={{ maxWidth: 500, marginTop: 20, fontWeight: 300, fontSize: 16, color: 'white' }}>
            OneT has partnered with the following renowned principals to deliver real business value and tangible
            benefits to our customers.
          </Typography>
        </Grid>

        <Grid
          style={{
            zIndex: 1,
            backgroundColor: 'White',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid
            style={{
              padding: 25,
              maxWidth: 1200,
              marginTop: 10,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              backgroundColor: 'Transparent',
            }}
          >
            <Typography
              style={{
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: 36,
                color: '#1b0049',
                textTransform: 'uppercase',
              }}
            >
              OUR PARTNERS
            </Typography>
          </Grid>

          <Grid container spacing={4} style={{ padding: 25, maxWidth: 1200 }}>
            {row.map((val) => (
              <Grid item sm={4} md={4} lg={3} xs={6}>
                <img src={val.img_fullPath} alt={val.title} width="100%" />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
